import Vue from 'vue'
import Vuex from 'vuex'
import { TokenService } from '@/services/storage.service';
import { localStore } from '@/services/local.storage';
Vue.use(Vuex)

const loggedIn = (TokenService.getToken() ? true : false )
var  isAdmin = false;
var isAgent = false;
var isVendor = false;
const role = atob(localStore.getLocalStorage('role'));


if(role == 'admin')
     isAdmin = true;
if(role == 'agent')
    isAgent = true;
if(role == 'vendor')
    isVendor = true;

export default new Vuex.Store({
    state: {
        user: {
            loggedIn: loggedIn,
            isAdmin: isAdmin,
            isAgent: isAgent,
            isVendor: isVendor
        }
    },
    getters: {
        auth(state) {
            return state.user
        }
    }
})